import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=660a3cfd&scoped=true&"
import script from "./Sports.js?vue&type=script&lang=js&"
export * from "./Sports.js?vue&type=script&lang=js&"
import style0 from "./Sports.scss?vue&type=style&index=0&id=660a3cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a3cfd",
  null
  
)

export default component.exports